/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdSlides200,
  GetApiV1ClassroomdisciplineIdSlides401,
  GetApiV1ClassroomdisciplineIdSlides404,
  GetApiV1ClassroomdisciplineIdSlidesPathParams,
  GetApiV1ClassroomdisciplineIdSlidesQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdSlides.ts";
import { slideMetadataViewModelSchema } from "../slideMetadataViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdSlidesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdSlides200Schema = z.array(
  z.lazy(() => slideMetadataViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlides200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdSlides401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlides401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdSlides404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlides404>;

export const getApiV1ClassroomdisciplineIdSlidesQueryResponseSchema = z.lazy(
  () => getApiV1ClassroomdisciplineIdSlides200Schema,
) as unknown as ToZod<GetApiV1ClassroomdisciplineIdSlidesQueryResponse>;
